<template>
  <div
    :class="[
      'mb-2',
      'px-3',
      'py-2',
      'text-center',
      'clickable',
      'job-question',
      'position-relative',
      {
        selected: isSelected,
      },
    ]"
    @click="$emit('select-question', jobQuestion.id)"
  >
    <b-row>
      <b-col>
        <span class="job-question-label">
          {{ label }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  getJobQuestionResponseValues,
  isJobQuestionAnswered,
} from '@/helpers/jobQuestionsHelper';
import { SETTINGS_KEYS } from '@/store';

export default {
  name: 'JobProfilePreferenceJobQuestion',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    isSelected: Boolean,
  },
  computed: {
    isJobQuestionAnswered: function () {
      return isJobQuestionAnswered(this.jobQuestion);
    },
    responseValues: function () {
      return getJobQuestionResponseValues(this.jobQuestion);
    },
    label: function () {
      const extraCharacter =
        this.$store.getters.getSetting(
          SETTINGS_KEYS.CHARACTER_FOR_JOB_QUESTION_LABEL
        ) || '';
      return `${this.jobQuestion.label}${extraCharacter}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';
.job-question {
  background: #FFFFFF 0 0 no-repeat padding-box;
  // border: 1px solid $phairify_v2_color_primary_teal;
  border: 1px solid #408293 !important;
  border-radius: 0px;
  opacity: 1;
  min-height: 80px;
  text-align: left;
  font: normal normal 600 20px/25px;
  letter-spacing: 0;
  color: #016178;
  .job-question-label {
    font: normal normal 600 20px/25px;
  }
  .job-question-answer {
    font: normal normal normal 20px/25px;
  }
  &.selected {
    color: $phairify_v2_color_white;
    background-color: $phairify_v2_color_primary_teal;
  }
}
</style>
